import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteStudent } from 'src/store/actions/student-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IStudent } from 'src/types/student';

interface Props {
    data: IStudent;
}

const DeleteStudentAction: React.FunctionComponent<Props> = ({ data: { id, firstName } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    return (
        <>
            <button type="button" className={'btn btn-secondary'} onClick={() => setOpened(true)}>
                <FontAwesomeIcon icon={faTrash} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete {`${firstName}`}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteStudent(
                                    id,
                                    () => {
                                        handleClose();
                                        toast.success('Student was successfully deleted.');
                                    },
                                    (errorMessage: string) => {
                                        handleClose();
                                        toast.error(errorMessage);
                                    },
                                ),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteStudentAction;
